import React, { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const CspCepMain = lazy(() => import('../cspcep/CspCepMain'));
const CspCepSchool = lazy(() => import('../cspcep/CspCepSchool'));
const CspCepSchoolList = lazy(() => import('../cspcep/CspCepSchoolList'));
const CspCepPlayersList = lazy(() => import('../cspcep/CspCepPlayersList'));

export default [
  {
    id: NavConfig.linkConfigs.CSP_SCHOOL.id,
    path: NavConfig.linkConfigs.CSP_SCHOOL.to,
    element: <CspCepSchool />,
  },
  {
    id: NavConfig.groupConfigs.CSP_CEP.id,
    path: NavConfig.groupConfigs.CSP_CEP.to,
    element: (
      <CspCepMain>
        <Suspense>
          <Outlet />
        </Suspense>
      </CspCepMain>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={NavConfig.linkConfigs.CEP_PLAYERS.to} />,
      },
      {
        id: NavConfig.linkConfigs.CEP_SCHOOLS.id,
        path: NavConfig.linkConfigs.CEP_SCHOOLS.to,
        element: <CspCepSchoolList />,
      },
      {
        id: NavConfig.linkConfigs.CEP_PLAYERS.id,
        path: NavConfig.linkConfigs.CEP_PLAYERS.to,
        element: <CspCepPlayersList />,
      },
    ],
  },
];
